import React, { JSX } from 'react';
import { ServiceId } from '@/@types/application';
import { SERVICES } from '../constants';
import { PostsPerPageType } from '../store';
import Style from './Filter.module.scss';

interface Props {
  postsPerPage: PostsPerPageType;
  serviceId?: ServiceId;
  changeService: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  chagePostsPerPage: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const Filter: React.FC<Props> = ({ postsPerPage, serviceId, changeService, chagePostsPerPage }): JSX.Element | null => {
  const targetService: string = serviceId === undefined ? '' : serviceId;

  return (
    <div className={Style.filter}>
      <form className={Style.form}>
        <div className={Style.services}>
          <label className={Style.label} htmlFor="service">
            サービスで絞り込む
          </label>
          <select name="service" value={targetService} onChange={(event) => changeService(event)}>
            <option value="">すべてのサービス</option>
            {Object.keys(SERVICES).map((serviceId) => {
              return (
                <option key={serviceId} value={serviceId}>
                  {SERVICES[serviceId]}
                </option>
              );
            })}
          </select>
        </div>
        <div className={Style.posts}>
          <label className={Style.label} htmlFor="postsPerPage">
            表示件数
          </label>
          <select name="postsPerPage" value={postsPerPage} onChange={(event) => chagePostsPerPage(event)}>
            <option value="10">10件</option>
            <option value="50">50件</option>
            <option value="100">100件</option>
          </select>
        </div>
      </form>
    </div>
  );
};

export default Filter;
